import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const { FiTrash2 } = FiIcons;
import SafeIcon from '../common/SafeIcon';

export default function DeleteConfirmModal({ onClose, onConfirm, title }) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" >
      <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="bg-gray-900 border border-red-900/30 rounded-xl w-full max-w-sm shadow-2xl p-6 text-center" >
        <div className="w-16 h-16 bg-red-900/20 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
          <SafeIcon icon={FiTrash2} className="text-3xl" />
        </div>
        <h2 className="text-xl font-bold text-white mb-2">Delete Snippet?</h2>
        <p className="text-gray-400 text-sm mb-6 break-words whitespace-normal">
          Are you sure you want to delete <span className="text-gray-200 font-semibold">"{title}"</span>? This action cannot be undone.
        </p>
        <div className="flex gap-3">
          <button onClick={onClose} className="flex-1 px-4 py-2 bg-gray-800 hover:bg-gray-700 text-gray-300 rounded-lg transition-colors"> Cancel </button>
          <button onClick={onConfirm} className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors"> Delete </button>
        </div>
      </motion.div>
    </motion.div>
  );
}